import { Link } from 'react-router-dom'
import { motion } from 'framer-motion'

const courses = [
  {
    id: 1,
    title: '法式马卡龙专修课',
    description: '深入学习法式马卡龙的制作工艺，掌握蛋白霜制作、配色技巧',
    price: '¥3,800',
    duration: '5天',
    level: '进阶',
    image: '/images/macaron.jpg',
  },
  {
    id: 2,
    title: '欧式面包综合课',
    description: '从基础到进阶，学习法式、意式、德式面包的经典制作',
    price: '¥4,500',
    duration: '7天',
    level: '零基础',
    image: '/images/bread.jpg',
  },
  {
    id: 3,
    title: '创意裱花课程',
    description: '韩式裱花、奶油霜调制、色彩搭配、造型设计',
    price: '¥3,200',
    duration: '4天',
    level: '初学者',
    image: '/images/cake-decor.jpg',
  },
  {
    id: 4,
    title: '精品甜品大师班',
    description: '蒙布朗、提拉米苏、巴斯克等经典甜品全面解析',
    price: '¥5,800',
    duration: '6天',
    level: '进阶',
    image: '/images/dessert.jpg',
  },
]

const features = [
  {
    icon: '🏆',
    title: '20年烘焙经验',
    description: '王老师从业20余年，曾任多家五星级酒店西点主厨',
  },
  {
    icon: '👨‍🏫',
    title: '小班精品教学',
    description: '每期学员不超过8人，确保教学质量，一对一指导',
  },
  {
    icon: '🎓',
    title: '权威资质认证',
    description: '学员完成课程后可获得国家认可的烘焙师资格证书',
  },
  {
    icon: '🏠',
    title: '创业扶持',
    description: '提供开店指导、配方输出、物料供应链等创业支持',
  },
]

const testimonials = [
  {
    name: '李小姐',
    avatar: '👩',
    content: '王老师的马卡龙课程真的太棒了！之前自己做了很多次都失败，在这里学会了技巧，现在做得非常成功！',
    course: '法式马卡龙专修课',
  },
  {
    name: '张先生',
    avatar: '👨',
    content: '零基础来学习，老师的讲解非常细致，现在已经开了自己的烘焙工作室，非常感谢王老师！',
    course: '欧式面包综合课',
  },
  {
    name: '王女士',
    avatar: '👩',
    content: '裱花技术提升了很多，课堂氛围很好，老师非常有耐心，推荐！',
    course: '创意裱花课程',
  },
]

export default function Home() {
  return (
    <div className="grain-overlay">
      {/* Hero Section */}
      <section className="relative min-h-[90vh] flex items-center bg-gradient-to-br from-cream via-cream to-champagne/10 overflow-hidden">
        {/* Decorative Elements */}
        <div className="absolute top-20 left-10 w-64 h-64 bg-caramel/10 rounded-full blur-3xl" />
        <div className="absolute bottom-20 right-20 w-96 h-96 bg-champagne/20 rounded-full blur-3xl" />

        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-20 relative z-10">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <motion.div
              initial={{ opacity: 0, x: -50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8 }}
            >
              <motion.span
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.2 }}
                className="inline-block px-4 py-2 bg-caramel/10 text-caramel rounded-full text-sm font-medium mb-6"
              >
                专注西点烘焙培训20年
              </motion.span>
              <h1 className="font-display text-5xl md:text-6xl lg:text-7xl text-chocolate leading-tight mb-6">
                传承法式烘焙
                <br />
                <span className="text-gradient">技艺之美</span>
              </h1>
              <p className="text-lg text-chocolate/70 mb-8 max-w-lg">
                来自法国蓝带厨艺学院的资深教师，带您领略西点烘焙的艺术与精髓。
                无论您是初学者还是想提升技艺，这里都能找到属于您的课程。
              </p>
              <div className="flex flex-wrap gap-4">
                <Link to="/courses" className="btn-primary text-lg">
                  浏览课程
                </Link>
                <Link to="/contact" className="px-8 py-3 border-2 border-caramel text-caramel rounded-lg font-medium hover:bg-caramel hover:text-white transition-all">
                  预约体验
                </Link>
              </div>

              {/* Stats */}
              <div className="flex gap-12 mt-12">
                <div>
                  <div className="font-display text-4xl text-caramel font-bold">5000+</div>
                  <div className="text-sm text-chocolate/60 mt-1">培养学员</div>
                </div>
                <div>
                  <div className="font-display text-4xl text-caramel font-bold">20年</div>
                  <div className="text-sm text-chocolate/60 mt-1">教学经验</div>
                </div>
                <div>
                  <div className="font-display text-4xl text-caramel font-bold">98%</div>
                  <div className="text-sm text-chocolate/60 mt-1">好评率</div>
                </div>
              </div>
            </motion.div>

            <motion.div
              initial={{ opacity: 0, x: 50 }}
              animate={{ opacity: 1, x: 0 }}
              transition={{ duration: 0.8, delay: 0.2 }}
              className="relative"
            >
              <div className="relative">
                <div className="absolute -inset-4 bg-gradient-to-r from-champagne to-caramel rounded-3xl blur-xl opacity-30" />
                <div className="relative rounded-3xl overflow-hidden aspect-square">
                  <img src="/images/hero-baking.jpg" alt="王老师烘焙" className="w-full h-full object-cover" />
                </div>
              </div>
              {/* Floating Elements */}
              <motion.div
                animate={{ y: [-10, 10, -10] }}
                transition={{ duration: 3, repeat: Infinity }}
                className="absolute -top-4 -right-4 bg-white rounded-2xl shadow-xl p-4"
              >
                <img src="/images/gallery-1.jpg" alt="蛋糕作品" className="w-16 h-16 object-cover rounded-lg" />
              </motion.div>
              <motion.div
                animate={{ y: [10, -10, 10] }}
                transition={{ duration: 4, repeat: Infinity }}
                className="absolute -bottom-4 -left-4 bg-white rounded-2xl shadow-xl p-4"
              >
                <img src="/images/bread.jpg" alt="面包作品" className="w-16 h-16 object-cover rounded-lg" />
              </motion.div>
            </motion.div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-4xl text-chocolate mb-4">为什么选择我们</h2>
            <p className="text-chocolate/60 text-lg max-w-2xl mx-auto">
              专业的教学团队、科学的课程体系、完善的创业支持
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
            {features.map((feature, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-cream rounded-2xl p-8 text-center card-hover"
              >
                <div className="text-5xl mb-4">{feature.icon}</div>
                <h3 className="font-display text-xl text-chocolate mb-3">{feature.title}</h3>
                <p className="text-chocolate/60">{feature.description}</p>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* Courses Section */}
      <section className="py-20 bg-gradient-to-b from-cream to-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-4xl text-chocolate mb-4">热门课程</h2>
            <p className="text-chocolate/60 text-lg max-w-2xl mx-auto">
              精心设计的课程体系，覆盖从入门到精通的各个阶段
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {courses.map((course, index) => (
              <motion.div
                key={course.id}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-white rounded-2xl overflow-hidden shadow-lg card-hover group"
              >
                <div className="aspect-[4/3] bg-gradient-to-br from-caramel/20 to-champagne/20 flex items-center justify-center">
                  <span className="text-6xl group-hover:scale-110 transition-transform">
                    {index === 0 ? '🧁' : index === 1 ? '🥖' : index === 2 ? '🎂' : '🍰'}
                  </span>
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-2 mb-2">
                    <span className="px-2 py-1 bg-caramel/10 text-caramel text-xs rounded-full">{course.level}</span>
                    <span className="text-xs text-chocolate/60">{course.duration}</span>
                  </div>
                  <h3 className="font-display text-lg text-chocolate mb-2">{course.title}</h3>
                  <p className="text-sm text-chocolate/60 mb-4 line-clamp-2">{course.description}</p>
                  <div className="flex items-center justify-between">
                    <span className="font-display text-2xl text-caramel">{course.price}</span>
                    <Link to="/courses" className="text-champagne hover:text-caramel font-medium text-sm">
                      了解详情 →
                    </Link>
                  </div>
                </div>
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/courses" className="btn-primary inline-block">
              查看全部课程
            </Link>
          </div>
        </div>
      </section>

      {/* Gallery Preview */}
      <section className="py-20 bg-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-4xl text-chocolate mb-4">作品展示</h2>
            <p className="text-chocolate/60 text-lg max-w-2xl mx-auto">
              精选学员作品，每一款都是用心制作的艺术品
            </p>
          </motion.div>

          <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
            {['gallery-1.jpg', 'gallery-2.jpg', 'gallery-3.jpg', 'gallery-4.jpg', 'gallery-5.jpg', 'gallery-6.jpg', 'macaron.jpg', 'bread.jpg'].map((img, item) => (
              <motion.div
                key={item}
                initial={{ opacity: 0, scale: 0.9 }}
                whileInView={{ opacity: 1, scale: 1 }}
                viewport={{ once: true }}
                transition={{ delay: item * 0.05 }}
                className="aspect-square rounded-xl overflow-hidden hover:scale-105 transition-transform cursor-pointer"
              >
                <img src={`/images/${img}`} alt="作品展示" className="w-full h-full object-cover" />
              </motion.div>
            ))}
          </div>

          <div className="text-center mt-12">
            <Link to="/gallery" className="text-caramel hover:text-champagne font-medium text-lg">
              查看更多作品 →
            </Link>
          </div>
        </div>
      </section>

      {/* Testimonials */}
      <section className="py-20 bg-chocolate">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
            className="text-center mb-16"
          >
            <h2 className="font-display text-4xl text-cream mb-4">学员评价</h2>
            <p className="text-cream/60 text-lg max-w-2xl mx-auto">
              听听来自学员的真实反馈
            </p>
          </motion.div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {testimonials.map((testimonial, index) => (
              <motion.div
                key={index}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ delay: index * 0.1 }}
                className="bg-cream/10 backdrop-blur-sm rounded-2xl p-8"
              >
                <div className="text-5xl mb-4">{testimonial.avatar}</div>
                <p className="text-cream/90 mb-6 leading-relaxed">"{testimonial.content}"</p>
                <div className="flex items-center justify-between">
                  <div>
                    <div className="font-medium text-cream">{testimonial.name}</div>
                    <div className="text-sm text-cream/60">{testimonial.course}</div>
                  </div>
                  <div className="text-champagne">★★★★★</div>
                </div>
              </motion.div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-20 bg-gradient-to-r from-caramel to-caramel-dark">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <motion.div
            initial={{ opacity: 0, y: 30 }}
            whileInView={{ opacity: 1, y: 0 }}
            viewport={{ once: true }}
          >
            <h2 className="font-display text-4xl text-white mb-6">准备好开始您的烘焙之旅了吗？</h2>
            <p className="text-white/80 text-lg mb-8">
              立即联系我们的课程顾问，获取专属学习方案
            </p>
            <div className="flex flex-wrap justify-center gap-4">
              <Link to="/contact" className="px-8 py-4 bg-white text-caramel rounded-lg font-semibold hover:bg-cream transition-colors">
                立即咨询
              </Link>
              <Link to="/courses" className="px-8 py-4 border-2 border-white text-white rounded-lg font-semibold hover:bg-white/10 transition-colors">
                浏览课程
              </Link>
            </div>
          </motion.div>
        </div>
      </section>
    </div>
  )
}